import { Routes, Route } from "react-router-dom";
import GeofenceLogs from "./GeofenceLogs";

const index = () => {
	return (
		<Routes>
			<Route index element={<GeofenceLogs />} />
		</Routes>
	);
};

export default index;
